import React, { useEffect, useRef, useState } from "react";
import "./Billing.css";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ClinicProfileGet, PostStripeconnect } from "../../../../api/helper";
import { setUserDetails } from "../../../../redux/cookiesReducer";
import { Store } from "../../../../redux";

function Billing() {
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const scope = queryParams.get("scope");
  const code = queryParams.get("code");
  const stateParam = queryParams.get("state");
  const hasConnectedRef = useRef(false);
  const [UserData, setUserData] = useState(null);

  const ConnectStripe = async () => {
    try {
      const Respo = await PostStripeconnect(
        `?scope=${scope}&code=${code}&state=${stateParam}`
      );
      getprofile();
      hasConnectedRef.current = true;
      const cleanUrl = location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    } catch (error) {
      console.log(error);
      getprofile();
    }
  };

  useEffect(() => {
    if (scope && code && stateParam && !hasConnectedRef.current) {
      hasConnectedRef.current = true;
      ConnectStripe();
    }
    getprofile();
  }, []);
  const getprofile = async (data) => {
    try {
      const response = await ClinicProfileGet();
      console.log(response.data);
      setUserData(response.data.data);
      Store.dispatch(setUserDetails(response?.data?.data));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="container_NotesTabScreen" style={{ width: "100%" }}>
      <h1>Connect Stripe</h1>

      <div className="stripe-card">
        <h2>Connect Stripe</h2>
        <p>
          EnnVital partners with Stripe for secure payments and financial
          services.
        </p>
        {!UserData?.isConnctedStripe && (
          <a
            href={`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_RkRPgRUMiL40OVg4U43sUTnn44823jZG&scope=read_write&state=${profiledata?._id}`}
            className="connect-btn"
          >
            Connect with Stripe
          </a>
        )}
        {UserData?.isConnctedStripe && (
          <p className="status connected">✅ Stripe Connected</p>
        )}
      </div>
    </div>
  );
}

export default Billing;
